import React, { Component } from 'react';
import { NextButton } from '../components/NextButton';
import { PreviousButton } from '../components/PreviousButton';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
}

export class SwitcherStabilityYes extends Component<IProps, any> {

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'><span className='doddltext'>Yes!</span> We can get you more stability</h1>
                <div className='wrapper'>
                    <div className='row'>
                        <p>90% of our customers choose fixed term rates - and there are options from 1 to 30 years!</p>
                    </div>
                    <div className='row'>
                        <h2><span className='doddltext'>Act now to lock in a longer term fixed rate</span></h2>
                    </div>
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.props.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow showDisclaimer />
                    </div>
                </div>
            </header>
        );
    }
}
